import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'typeParametre'})
export class TypeParametrePipe implements PipeTransform {

    transform(value: string): string {
        switch (value) {
            case 'TEXTE' :
                return 'Texte';
            case 'NOMBRE' :
                return 'Nombre';
            case 'BOOLEEN' :
                return 'Booléen';
            case 'LISTE_CHOIX' :
                return 'Liste de choix';
            case 'DATE' :
                return 'Date';
            case 'COULEUR' :
                return 'Couleur';
            case 'URL' :
                return 'URL';
            case 'LOT' :
                return 'Zone';
            case 'PIECE' :
                return 'Pièce';
            case 'OUVRAGE' :
                return 'Ouvrage';

        }
    }

}
